const getters = {

	// COMPONENT
		// vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),

	CAMPAIGNLIST: state => {
		return state.campaignListState;
	},

	ABTEST_FOR_NEW_AD: state => {
		return state.abTestForNewAd;
	},

	TEST_ID_FOR_RELOAD_FORM: state => {
		return state.testIdForReloadForm;
	},

	WHIMAGE: state => {
		return state.whImage;
	},


};

export default getters